import {
  initializeViewState,
  removeViewState,
  selectViewState,
  useAppDispatch,
  useAppSelector,
  type Vmid,
} from '@salescore/client-redux'
import { useEffect } from 'react'

/**
 * ビューマウント時に Redux ストアでの状態を一度だけ初期化し、アンマウント時にクリーンアップするフックです。
 * 返り値は Redux ストアに ViewState が初期化済みかどうかです。
 *
 * @param viewId - 初期化するビューのID
 * @param pageSize - ビューが一度に読み込むルートレコードの数
 *
 * @returns 初期化済みなら true、初期化中は false
 */
export const useInitializeViewState = ({
  viewId,
  vmid,
  pageSize,
}: {
  viewId: string
  vmid: Vmid
  pageSize: number
}): boolean => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(initializeViewState({ vmid, viewId, pageSize }))
    return (): void => {
      dispatch(removeViewState(vmid))
    }
  }, [])
  return useAppSelector((state) => selectViewState(state, vmid) !== undefined)
}
